import React from 'react';
import InputNumber from '@base/lib/InputNumber';
import { CartItemType } from '@base/cart/interface';
import { isBonusProduct } from 'base/utils/product';
import { useTrans } from 'base/utils/i18n';

type CartItemQtyProps = {
    className?: string;
    item: CartItemType;
    onChangeItemNum: (itemId: string, num: number) => void;
    batchActive?: boolean;
    changeable?: boolean;
};

const CartItemQty: React.FC<CartItemQtyProps> = props => {
    const { t } = useTrans();
    const {
        item,
        className,
        onChangeItemNum,
        batchActive = false,
        changeable = true
    } = props;

    const {
        id,
        stockNum,
        num
    } = item;

    return (
        <div className={className}>
            {isBonusProduct(item) || !changeable
                ? <span className="g-qty-text">{t('web_common_qty')}: {num}</span>
                : (
                    <InputNumber
                        className={'g-qty-input'}
                        disabled={stockNum === 0 || batchActive}
                        value={num}
                        onChange={num => onChangeItemNum(id, Number(num))}
                        min={1}
                    />
                )}
        </div>
    )
};

export default CartItemQty;